import { useDispatch } from 'react-redux';
import i18n from 'i18next';
import { useMutation } from '@tanstack/react-query';

import { setAppLoader } from '@/redux/common/CommonActions';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { createPreClaim } from '../data-provider/save-claim';
import type { PreClaimData } from '../data-provider/save-claim/api';

export const useCreatePreClaim = () => {
  // const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: ({ payload }: { payload: PreClaimData; callback: (claimNumber: number) => void }) =>
      createPreClaim(payload),
    onError: (error) => {
      showNotification({
        message: error.message || i18n.t('translation:default.fields.somethingWentWrong'),
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onMutate: () => {
      dispatch(setAppLoader(true));
    },
    onSettled: () => {
      dispatch(setAppLoader(false));
    },
    onSuccess: (preClaimCreatedNumber, variables) => {
      // todo: claims update
      // queryClient.invalidateQueries({
      //   queryKey: ['all-claims-list'],
      // });
      variables.callback?.(preClaimCreatedNumber);
    },
  });
};
